import { Link } from "react-router-dom";

const safetyRisks = [
  { risk: "Fake websites", solution: "Verify official sources" },
  { risk: "Unknown files", solution: "Avoid untrusted downloads" },
  { risk: "Data exposure", solution: "Protect private information" },
  { risk: "Password risks", solution: "Use secure passwords" },
  { risk: "Phishing attempts", solution: "Check URLs carefully" },
  { risk: "Outdated software", solution: "Keep tools updated" },
];

export default function SafetySection() {
  return (
    <section id="safety" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-5">
            <i className="ri-shield-check-line text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Is Vigorbuy Spreadsheet Safe?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Security and privacy are important when using any online spreadsheet solution. Always verify official resources, avoid suspicious downloads and protect sensitive information.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70 mb-8">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-foreground-800 text-background-50">
                <th className="text-left px-5 py-3.5 font-label font-semibold">Risk</th>
                <th className="text-left px-5 py-3.5 font-label font-semibold">Solution</th>
              </tr>
            </thead>
            <tbody>
              {safetyRisks.map((item, idx) => (
                <tr
                  key={item.risk}
                  className={`border-b border-background-200/50 ${
                    idx % 2 === 0 ? "bg-background-50" : "bg-background-100/60"
                  }`}
                >
                  <td className="px-5 py-3 text-foreground-700">
                    <span className="flex items-center gap-2">
                      <i className="ri-error-warning-line text-secondary-600"></i>
                      {item.risk}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-accent-700 font-medium">
                    <span className="flex items-center gap-2">
                      <i className="ri-check-fill text-accent-500"></i>
                      {item.solution}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-label font-semibold bg-accent-500 text-background-50 rounded-md hover:bg-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Read Vigorbuy Spreadsheet Safety Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}